import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";
import axios from "axios";
import { API_BASE_URL } from "@/constants";

Vue.use(AclInstaller);

let initialRole = "ROLE_EDITOR";
if (localStorage.getItem("userRole")) {
  initialRole = localStorage.getItem("userRole");
}

console.log("initialRole", initialRole);

export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/not-authorized",
  router,
  acceptLocalRules: true,
  globalRules: {
    hasRoleSysadmin: new AclRule("ROLE_SYSADMIN").generate(),
    hasRoleAdmin: new AclRule("ROLE_ADMIN").or("ROLE_SYSADMIN").generate(),
    hasRoleEditor: new AclRule("ROLE_EDITOR")
      .or("ROLE_ADMIN")
      .or("ROLE_SYSADMIN")
      .generate(),
    hasRoleViewer: new AclRule("ROLE_VIEWER")
      .or("ROLE_OBSERVE_EXCISE_TANKER")
      .or("ROLE_EDITOR")
      .or("ROLE_ADMIN")
      .or("ROLE_SYSADMIN")
      .generate()
  }
});
